var footerBlocks = document.querySelectorAll('.footer-block');
if (footerBlocks) {
  footerBlocks.forEach((footerBlock) => {
    footerBlock.addEventListener('click', () => {
      const content = footerBlock.querySelector('.footer-block__details-content');
      content.classList.toggle('active');
    });
  });
}

const body = document.querySelector('body');
if (body.classList.contains('store-finder') || body.classList.contains('template-events')){
      const cityButtons = document.querySelectorAll('.city-list-wrap li');
      const rows = document.querySelectorAll('.row');

      cityButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
              event.preventDefault();
              cityButtons.forEach(cityButton => {
                  cityButton.classList.remove('active');
              });
              button.classList.add('active');
              rows.forEach(row => {
                  row.classList.remove('active');
              });
              rows[index].classList.add('active');
          });
      });
}
document.addEventListener('DOMContentLoaded', function() {
  const popupClose = document.querySelector("button.close.popup__close");
  if (popupClose) {
    popupClose.addEventListener("click", function() {
      document.querySelector(".popup-section.jsPopup").classList.add("close");
      document.querySelector("body").classList.remove("popup-open");
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('.soldout.grid__item');
    elements.forEach(element => {
        const anchor = element.querySelector('a[href^="/pages/boredom-busting-2"]');
        if (anchor) {
            element.style.display = 'none';
        }
    });
});
